import axiosClient from 'api/axiosClient';
import { decryption, expireTime } from 'utils';
import useToaster from 'hooks/store/toast/useToaster';
import Cookies from 'universal-cookie';
import useSocketStore, { initinalSokectValues } from 'hooks/store/messages/useSocketStore';
import useLoginStore from '../../store/common/useLoginStore';
import useChatMessages, { initialChatMessagesState } from '../../store/conversations/useChatMessages';

interface loginUserReq {
  // IA-500 / IA-1092: the originating admin is derived server-side from the verified
  // JWT/session; the client no longer sends a (spoofable) masterUserId.
  userId: string;
}

export default function useLoginAs() {
  const toaster = useToaster();
  const cookies = new Cookies();
  const socketData = useSocketStore().getState();
  const { setState: setUpdate } = useLoginStore();
  const { setState: setChatState } = useChatMessages();

  const loginAsUser = async (req: loginUserReq, match: boolean) => {
    setChatState({ ...initialChatMessagesState });
    socketData.socket?.close?.();
    try {
      const data = await axiosClient.post('/admin/loginAs', req).then(res => res.data.data);

      if (!data.error) {
        if (match) {
          cookies.set('user', data.data, { path: '/', expires: expireTime() });
          const user = decryption(data.data);
          const switchAccountDisplayUser = {
            firstName: user?.firstName ?? '',
            lastName: user?.lastName ?? '',
            preferredFirstName: user?.preferredFirstName ?? '',
            profilePic: user?.profilePic ?? '',
          };
          sessionStorage.setItem('userProfilePic', user?.profilePic ?? '');
          sessionStorage.setItem('switchAccountUser', JSON.stringify(switchAccountDisplayUser));
          setUpdate({ loginResponse: user });
          socketData.setState({ ...initinalSokectValues });
          window.location.replace('/switch-account');
        }
        return true;
      }

      toaster.showToast('Danger', data.msg);
      return false;
    } catch (error: any) {
      if (error.response?.status !== 401) {
        toaster.showToast('Danger', error.response?.data?.msg ?? 'An error occurred');
      }
      return false;
    } finally {
    }
  };

  return {
    loginAsUser,
  };
}
